import { DataQualityExpectationSelect } from "src/pages/DataAssets/views/Expectations/DataQualityExpectationSelect.tsx"
import { ExpectationEditorSimplified } from "src/pages/DataAssets/views/Expectations/Expectation/ExpectationEditorSimplified.tsx"
import { ExpectationMetaInfo } from "src/global/schemas/expectations/expectation-metadata-utils.ts"
import { AlertBanner } from "src/global/ui/Alert"
import { Form, FormInstance } from "antd"
import { DataQualityIssue } from "src/global/schemas/expectations/expectation-metadata-data-quality-issues.ts"
import { SelectedExpectation } from "src/pages/DataAssets/views/Expectations/Expectation/CreateExpectationDrawer/types.ts"
import { FragmentType } from "src/api/graphql"
import { ExpectationEditor_DataAssetMetricRunFragmentDoc } from "src/api/graphql/graphql.ts"
import { ApolloError } from "@apollo/client"

type Props = {
  form: FormInstance
  selectedDataQualityIssue: DataQualityIssue | undefined
  onSelectExpectation: (expectation: SelectedExpectation) => void
  selectedExpectation: SelectedExpectation
  expectationConfiguration: Record<string, unknown>
  handleConfigChange: (newConfig: Record<string, unknown>) => void
  dataAsset: FragmentType<typeof ExpectationEditor_DataAssetMetricRunFragmentDoc> | undefined
  addExpectationToAssetError: ApolloError | undefined
}

export function ExplicitExpectationEditor({
  form,
  selectedDataQualityIssue,
  onSelectExpectation,
  selectedExpectation,
  expectationConfiguration,
  handleConfigChange,
  dataAsset,
  addExpectationToAssetError,
}: Props) {
  return (
    <Form form={form} layout="vertical">
      <DataQualityExpectationSelect
        selectedDataQualityIssue={selectedDataQualityIssue}
        onSelectExpectation={onSelectExpectation}
        selectedExpectation={selectedExpectation}
      />
      <ExpectationEditorSimplified
        value={expectationConfiguration}
        expectationMetaInfo={{ ...selectedExpectation, type: selectedExpectation.value } as ExpectationMetaInfo}
        onChange={handleConfigChange}
        dataAsset={dataAsset}
        showInfo={false}
      />
      {addExpectationToAssetError && (
        <AlertBanner message="Failed to add Expectation" description={addExpectationToAssetError.message} />
      )}
    </Form>
  )
}
